import React from 'react'
import { Link } from 'react-router-dom'
import AuthLayout, { AUTH_ACCENT, authFieldClass } from '../../../components/AuthLayout'
import { AlertIcon } from '../../../template/kartera/icons'
import { LOGIN_PATH, useRegisterFormModel } from './register-form-model'

const RegisterForm = () => {
    const model = useRegisterFormModel()

    return (
        <AuthLayout helpText="¿Necesitas ayuda?">
            <div className="flex flex-col gap-1.5">
                <h2 className="m-0 text-[28px] font-extrabold tracking-[-0.03em]">Crea tu cuenta</h2>
                <p className="m-0 text-[15px] text-k-muted">Te enviaremos un correo para activarla y crear tu contraseña.</p>
            </div>
            {model.submitError && (
                <div role="alert" className="flex gap-2.5 rounded-xl bg-k-danger-soft px-3.5 py-3 text-sm font-semibold text-k-danger">
                    <AlertIcon className="shrink-0" />
                    {model.submitError}
                </div>
            )}
            <form className="flex flex-col gap-3.5" onSubmit={model.submit} noValidate>
                <label className="flex flex-col gap-1.5 text-sm font-bold">
                    Correo electrónico
                    <input
                        type="email"
                        autoComplete="email"
                        value={model.email}
                        aria-invalid={model.invalid.email}
                        placeholder="nombre@correo.com"
                        onChange={(event) => model.setEmail(event.target.value)}
                        onBlur={model.validateEmail}
                        className={authFieldClass(model.invalid.email)}
                    />
                    {model.emailError && <span className="text-[13px] font-medium text-k-danger">{model.emailError}</span>}
                </label>
                <label className="flex flex-col gap-1.5 text-sm font-bold">
                    Nombres
                    <input
                        type="text"
                        autoComplete="given-name"
                        value={model.nombres}
                        aria-invalid={model.invalid.nombres}
                        onChange={(event) => model.setNombres(event.target.value)}
                        className={authFieldClass(model.invalid.nombres)}
                    />
                </label>
                <div className="grid grid-cols-2 gap-3">
                    <label className="flex min-w-0 flex-col gap-1.5 text-sm font-bold">
                        Apellido paterno
                        <input
                            type="text"
                            autoComplete="family-name"
                            value={model.apPat}
                            aria-invalid={model.invalid.apPat}
                            onChange={(event) => model.setApPat(event.target.value)}
                            className={authFieldClass(model.invalid.apPat)}
                        />
                    </label>
                    <label className="flex min-w-0 flex-col gap-1.5 text-sm font-bold">
                        Apellido materno
                        <input
                            type="text"
                            autoComplete="additional-name"
                            value={model.apMat}
                            onChange={(event) => model.setApMat(event.target.value)}
                            className={authFieldClass(false)}
                        />
                    </label>
                </div>
                <label className={`flex items-start gap-2.5 rounded-xl bg-k-surface px-3.5 py-3 text-[13px] leading-[1.5] text-k-ink-2 ${model.invalid.terms ? 'border-2 border-k-danger' : 'border border-k-line'}`}>
                    <input
                        type="checkbox"
                        checked={model.terms}
                        aria-invalid={model.invalid.terms}
                        onChange={model.toggleTerms}
                        className="mt-px h-[18px] w-[18px] shrink-0"
                        style={{ accentColor: AUTH_ACCENT }}
                    />
                    <span>
                        Acepto los <Link to="/terminos-condiciones" className="font-bold text-k-accent-ink no-underline">términos y condiciones del servicio</Link>.
                    </span>
                </label>
                {model.missing.length > 0 && (
                    <span role="alert" className="text-[13px] font-semibold text-k-danger">Falta: {model.missing.join(', ')}.</span>
                )}
                <button
                    type="submit"
                    disabled={model.loading}
                    className="flex h-[52px] items-center justify-center gap-2.5 rounded-[14px] border-0 text-base font-extrabold text-white"
                    style={{ background: AUTH_ACCENT, opacity: model.loading ? 0.85 : 1, cursor: model.loading ? 'progress' : 'pointer' }}
                >
                    {model.loading && <span aria-hidden="true" className="h-[18px] w-[18px] rounded-full border-2 border-white/40 border-t-white" style={{ animation: 'k-spin 0.8s linear infinite' }} />}
                    {model.loading ? 'Creando cuenta…' : 'Crear cuenta'}
                </button>
            </form>
            <p className="m-0 border-t border-k-line pt-[18px] text-center text-sm text-k-muted">
                Ya tengo cuenta ·{' '}
                <Link to={LOGIN_PATH} className="font-bold text-k-accent-ink no-underline">Iniciar sesión</Link>
            </p>
        </AuthLayout>
    )
}

export default RegisterForm
